import { ICurrentUser, IUserTokens } from '../currentuser/currentUser';
import { AnalyticsEvent } from './AnalyticsEvent';
import { mobileConfig } from '../commons/config';
import { isSmallerThanTablet } from '../responsive/hooks/hooks';
import { addEventToBuffer } from './analyticsBuffer';
import { sendAnalyticsEventDirectly } from './analyticsSender';
import * as amplitude from '@amplitude/analytics-browser';
import { Page } from './Page';

export const getStandardCustomProperties = () => {
  const config = mobileConfig();
  return {
    isMobileApp: config.isMobile,
    growegyPlatform: config.growegyMobilePlatform
      ? config.growegyMobilePlatform
      : isSmallerThanTablet()
      ? 'mobile-web'
      : 'web',
  };
};

export const analyticsReset = () => {
  analyticsTrack(AnalyticsEvent.USER_SIGNED_OUT);
  amplitude.reset();
};

export const analyticsIdentifyUser = async (
  currentUser: ICurrentUser,
  tokens: IUserTokens | null
) => {
  try {
    amplitude.setUserId(currentUser.userId);

    const roles = currentUser.roles.map((x) => x.id).join(',');
    amplitude.track(
      `${AnalyticsEvent.USER_SIGNED_IN.entity} ${AnalyticsEvent.USER_SIGNED_IN.action}`,
      {
        roles,
        ...getStandardCustomProperties(),
      }
    );

    await sendAnalyticsEventDirectly(AnalyticsEvent.USER_SIGNED_IN, { roles }, tokens);
  } catch (err) {
    logger.error('Error while identifying user: ', err);
  }
};

export const analyticsTrack = (analyticsEvent: AnalyticsEvent | Page, properties: object = {}) => {
  const eventName =
    analyticsEvent instanceof AnalyticsEvent
      ? analyticsEvent.name
      : analyticsEvent.visitedEventName;
  logger.info(`Reporting analytics event: ${eventName}`, properties);
  try {
    amplitude?.track(eventName, {
      ...properties,
      ...getStandardCustomProperties(),
    });
    addEventToBuffer(eventName, properties);
  } catch (err) {
    logger.error('Error while reporting analytics event: ', err);
  }
};
